export enum RoleType {
  SUPER_ADMIN= "SUPER_ADMIN",
  ADMIN = "ADMIN"
}

export const RoleTypes = [
  {name: "Tài khoản quản trị hệ thống", value: RoleType.SUPER_ADMIN, color: 'red'},
  {name: "Tài khoản quản trị", value: RoleType.ADMIN, color: 'cyan'}
];
